export const handleBack = async (
  activeStep: number,
  setActiveStep: (step: number) => void,
  stepsStatus: Array<"wait" | "process" | "finish" | "error">,
  setStepsStatus: (step: Array<"wait" | "process" | "finish" | "error">) => void
) => {
  const updatedStatus = [...stepsStatus];
  switch (activeStep) {
    case 0:
      setStepsStatus(updatedStatus);
      break;
    case 1:
      updatedStatus[activeStep] = "wait"; // Reseta a etapa atual
      updatedStatus[activeStep - 1] = "process"; // Etapa anterior em processo
      setStepsStatus(updatedStatus);
      setActiveStep(activeStep - 1);
      break;

    case 2:
      updatedStatus[activeStep] = "wait"; // Reseta a etapa atual
      updatedStatus[activeStep - 1] = "process"; // Etapa anterior em processo
      setStepsStatus(updatedStatus);
      setActiveStep(activeStep - 1);
      break;
  }
};
